import { Modal, ModalProps } from "react-bootstrap";
import { TickSuccess } from "../icon";
import { getPortraitStageContainer } from "../PortraitStage";

interface SuccessScanModalProps extends ModalProps {
  onHide: () => void;
}

const SuccessScanModal = (props: SuccessScanModalProps) => {
  return (
    <Modal
      container={getPortraitStageContainer}
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="commonModal"
    >
      <Modal.Body className="text-center" style={{ padding: 48 }}>

        <TickSuccess />
        <div className="loaderTxtScan">
          QR Code Ticket <br /> Successfully verified!
        </div>
      </Modal.Body>
    </Modal >
  );
};

export default SuccessScanModal;
